import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Menu from "@/components/site/Menu";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";

export default function Landing() {
  return (
    <main>
      <Hero />
      <Marquee />
      <About />
      <Menu />
      <Services />
      <Gallery />
      <Contact />
    </main>
  );
}
